import { gql } from '@apollo/client';

const MANIFEST_FRAGMENT = gql`
  fragment MANIFEST_FIELDS on Manifest {
    id
    name
    title
    capabilities
    metadata {
      cardMedia
      ctaButtonText
      ctaButtonUrl
      developerName
      hasTOSAgreeOnInstall
      icon
      media {
        url
        type
      }
      overviewDescription {
        title
        content
      }
      price
      rate
      releaseDate
      shortDescription
      termsOfServiceText
      title
      urls {
        privacyPolicyUrl
        termsOfServiceUrl
        settingsUrl
        supportUrl
        developerUrl
      }
      vendorName
      badge
    }
  }
`;

export const GET_APPLICATIONS = gql`
  query ($input: FindAllApplicationsInput!) {
    ExtensionsRegistry {
      application {
        findAll(input: $input) {
          id
          category
          status
          tiers
          isInstalled
          manifest {
            ...MANIFEST_FIELDS
          }
          config
          slugUrl
        }
      }
    }
  }
  ${MANIFEST_FRAGMENT}
`;

export const GET_APPLICATIONS_FOR_PATIENT = gql`
  query ($input: FindAllApplicationsForPatientInput!) {
    ExtensionsRegistry {
      application {
        findAllForPatient(input: $input) {
          id
          manifest {
            ...MANIFEST_FIELDS
          }
        }
      }
    }
  }
  ${MANIFEST_FRAGMENT}
`;

export const ACTIVATE = gql`
  mutation ($input: ActivateExtensionInput!) {
    ExtensionsRegistry {
      clientExtension {
        activate(input: $input)
      }
    }
  }
`;

export const DEACTIVATE = gql`
  mutation ($input: DeactivateExtensionInput!) {
    ExtensionsRegistry {
      clientExtension {
        deactivate(input: $input)
      }
    }
  }
`;

export const CREATE_CONFIGURATION = gql`
  mutation ($input: CreateConfigurationInput!) {
    ExtensionsRegistry {
      configuration {
        create(input: $input) {
          extensionId
          config
        }
      }
    }
  }
`;

export const UPDATE_CONFIGURATION = gql`
  mutation ($input: UpdateConfigurationInput!) {
    ExtensionsRegistry {
      configuration {
        update(input: $input) {
          extensionId
          config
        }
      }
    }
  }
`;

export const GENERATE_APP_TOKEN = gql`
  mutation ($input: GenerateAppTokenInput!) {
    ExtensionsRegistry {
      appToken {
        generateAppToken(input: $input) {
          token
        }
      }
    }
  }
`;
